// filepath: /src/components/FrostedGlassMenu.js
import React, { useState, useEffect } from 'react';
import useSmoothScroll from '../hooks/useSmoothScroll';
import useAuth from '../hooks/useAuth';
import LoginModal from './Auth/LoginModal';
import UserMenu from './Auth/UserMenu';
import './FrostedGlassMenu.css';


const FrostedGlassMenu = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const { user, login, logout } = useAuth();
  const { handleAnchorClick } = useSmoothScroll();

  const handleNavClick = (href) => {
    setIsMobileMenuOpen(false);
    handleAnchorClick(href);
  };

  const handleLogin = (userData) => {
    login(userData);
    setIsLoginModalOpen(false);
  };

  const handleLogout = () => {
    logout();
  };

  const handleAccessClick = () => {
    if (user) {
      // Si ya está logueado, ir a la sección de acceso
      handleNavClick('#acceso-sistema');
    } else {
      // Si no está logueado, abrir modal de login
      setIsLoginModalOpen(true);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { href: '#hero', label: 'Inicio' },
    { href: '#nosotros', label: 'Nosotros' },
    { href: '#features', label: 'Características' },
    { href: '#gallery', label: 'Galería' },
    // { href: '#planes', label: 'Planes' },
    { href: '#licencias', label: 'Licencias' },
    { href: '#acceso-sistema', label: 'Acceso' },
    { href: '#contacto', label: 'Contacto' }
  ];

  return (
    <nav className={`frosted-navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          {/* <div className="logo-icon"> */}
            {/* <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="12" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 16l3 3 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg> */}
            {/* <img src={require('../assets/imagenes/think-health.svg')} alt="Logo Think Health" width={32} height={32} /> */}
                {/* <img src={Logo} alt="logo" width={60} height={60} /> */}

            <img  
              width="80" 
              height="80" 
              src={require('../assets/imagenes/think-health-gradient-white-blue.png')} 
              alt="Think Health Logo"
              style={{ marginTop: '10px' }}
            />
            {/* <img width="60" height="50" src={require('../assets/imagenes/think-health-transparent.png')} /> */}

          {/* </div> */}
          <span className="logo-text">Think Health</span>
        </div>

        {/* Desktop Navigation */}
        <div className="navbar-menu desktop-menu">
          {navItems.map((item, index) => (
            <button
              key={index}
              className="nav-item glass-button-nav"
              onClick={() => handleNavClick(item.href)}
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* CTA Button / User Menu */}
        <div className="navbar-cta">
          {user ? (
            <UserMenu user={user} onLogout={handleLogout} />
          ) : (
            <button 
              className="glass-button primary"
              onClick={handleAccessClick}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 1v14M1 8h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              Acceder
            </button>
          )}
        </div>

        {/* Mobile Menu Button */}
        <button 
          className={`mobile-menu-button ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle mobile menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          {navItems.map((item, index) => (
            <button
              key={index}
              className="mobile-nav-item"
              onClick={() => handleNavClick(item.href)}
            >
              {item.label}
            </button>
          ))}
          {/* Solo mostrar botón de login si el usuario NO está logueado */}
          {!user && (
            <button 
              className="glass-button primary mobile-cta"
              onClick={handleAccessClick}
            >
              Iniciar Sesión
            </button>
          )}
        </div>
      </div>
      
      {/* Login Modal */}
      <LoginModal 
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        onLogin={handleLogin}
      />
    </nav>
  );
};

export default FrostedGlassMenu;
